import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResendSuccessComponent } from './resend-success.component';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@NgModule({
  declarations: [ResendSuccessComponent],
  imports: [CommonModule, TranslateModule],
  exports: [ResendSuccessComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],
})
export class ResendSuccessModule {}
